import { Email } from './styles'

const Component = ({ children }:any) => {
	return <Email>{children}</Email>
}

export default Component